import {useCallback, useEffect, useMemo, useState} from 'react';
import {useUnit} from '../../../../hooks/services/useUnit';
import {ProcessSubscription,} from '../../../../models/ProcessSubscription';
import {useParams} from 'react-router-dom';


export const useUnitManagementSubscriptions = () => {
  const {
    saveUnitManageProcessSubscription,
    getUnitManageProcessSubscription,
    saveUnitManageBranchProcessSubscription,
  } = useUnit();
  const {unitId} = useParams();
  const [processesWithSubscibers, setProcessesWithSubscibers] = useState<
    ProcessSubscription[]
  >([]);

  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [modifiedSubscriptions, setModifiedSubscriptions] = useState<ProcessSubscription[]>([]);
  const [modifiedBranchSubscriptions, setModifiedBranchSubscriptions] = useState<ProcessSubscription | null>(null);


  const loadData = useCallback(
    async (unitId: number) => {
      setIsLoading(true);
      const data = await getUnitManageProcessSubscription(unitId);
      if (data.result) 
      {
        setProcessesWithSubscibers(data.result)
      }
      setIsLoading(false);
    },
    [getUnitManageProcessSubscription]
  );

  useEffect(() => {
    if (unitId) loadData(Number.parseInt(unitId));
  }, [unitId, loadData]);



  const saveSubscriptions = useCallback(
    async (modifiedSubscriptions: ProcessSubscription[], modifiedBranchSubscriptions: ProcessSubscription | null) => {
      
      if(!unitId) {
        return;
      }
      setIsLoading(true);
      
      if (modifiedSubscriptions.length > 0) {
        await saveUnitManageProcessSubscription(Number.parseInt(unitId), modifiedSubscriptions);
      }
      if(modifiedBranchSubscriptions != null) {
        console.log(modifiedBranchSubscriptions);
        await saveUnitManageBranchProcessSubscription(Number.parseInt(unitId), modifiedBranchSubscriptions);
      }

      await loadData(Number.parseInt(unitId));
      setModalOpen(false);
      setIsLoading(false);
      setModifiedBranchSubscriptions(null);
      setModifiedSubscriptions([]);

    },
    [unitId, saveUnitManageProcessSubscription, loadData,saveUnitManageBranchProcessSubscription]
  );



  return useMemo(
    () => ({
      processesWithSubscibers,
      unitId,
      isLoading,
      saveSubscriptions,
      setModalOpen,
      modalOpen,
      modifiedSubscriptions,
      setModifiedSubscriptions,
      modifiedBranchSubscriptions,  
      setModifiedBranchSubscriptions

      
    }),
    [processesWithSubscibers, unitId, isLoading,saveSubscriptions, setModalOpen, modalOpen, modifiedSubscriptions, setModifiedSubscriptions, modifiedBranchSubscriptions, setModifiedBranchSubscriptions]
  );
};


